import {
  COMPANION_PANEL_PATH,
  companionPanelKeys,
} from '@/hooks/queries/use-companion-panel-conversation-query';
import api from '@/libs/axiosInstance';
import { useMutation, useQueryClient } from '@tanstack/react-query';

/**
 * The pencil: the current conversation is archived and the panel starts a new
 * one. Drafts it prepared are kept server-side. Refused (409) while a turn runs,
 * which is why the panel hides the pencil while it answers.
 */
export const useArchiveCompanionPanelConversation = (brandId: string) => {
  const queryClient = useQueryClient();

  return useMutation<void, Error>({
    mutationFn: async () => {
      await api.post(`${COMPANION_PANEL_PATH}/conversation/archive`);
    },
    onSuccess: () => {
      queryClient.setQueryData(companionPanelKeys.conversation(brandId), null);
    },
    // Refused while a turn runs (in another tab, say): read the turn it is waiting for.
    onError: () => {
      void queryClient.invalidateQueries({ queryKey: companionPanelKeys.conversation(brandId) });
    },
  });
};
